import React from 'react';

export default () => {
	return (
    <div className="banner-container">
			<div className="banner-bar"></div>
		</div>
	);
}